import PhotoswipeComponent from './PhotoswipeComponent.vue';

let $vm;

export default {
    install(Vue) {
        const PhotoSwipe = Vue.extend(PhotoswipeComponent);

        // Add the photoswipe element to the bottom of the page if it doesn't already exist
        if (!$vm) {
            $vm = new PhotoSwipe({ el: document.createElement('div') })
            document.body.appendChild($vm.$el);
        }

        Vue.$photoswipe = {
            open(refs, index, items, options) {
                $vm.open(refs, index, items, options);
            },
            close() {
                $vm.close();
            }
        };

        Vue.mixin({
            created() {
                this.$photoswipe = Vue.$photoswipe;
            }
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/core/components/Photoswipe/index.js